//import  Navs  from "./nav_2.js";

export default function Aboutme() {
  return (
      <div className="aboutme">
    
        <p className="aboutrow">
        <h2 style={{ fontStyle: 'italic' }}> LAB RAT </h2>
        <h3> Lifelong Learner📚, Advocate🧑‍⚖️, Biohacker🧬, Researcher🥼, Artist🎭, and Technologist🧑‍💻 </h3>
        <p></p>
        <h4 className="black"> 
          Welcome, Earthling! I'm Tre, an autodidact, lifelong learner and interdisciplinary researcher with a goal of learning each valuable skill necessary to pioneer the change that I wish to see in the world!
          From frontend engineering to AI, I am on the path to mastering engineering ideas from scratch. I have experience using a lot of different tools, but my specialties lean towards full-stack websites with AI functionality.
          I have paused all projects in order to focus one larger scale project that allows me to build each piece myself while adding data visualization to my toolbelt.
          I aim to feel limitless when I conjure up a new idea. There is no thing that I am not willing to learn to bring a creation to life.
          So while these are my specialities for now, I hope to broaden that a bit when I extended further into computer science and engineering with hardware, embdeed systems, IT and more.
          I hope to continually gain experience to grow myself professionally and offer the same to the schools and
          organizations that I work with as I work towards a greater goal of personal development and global change.
        </h4>
          
        </p>
      </div>
    )
  }

/*
        //<Navs Education="/education" Skills="/skills" Projects="/projects"/>

        Hopefully on track to be Tenured Professor (currently teaching k-12), Attorney (in law school), Biohacker (combining knowledge of human body and computer science to advance human medicine over the next decade or so),
        Biomedical Engineer (bringing something to market soon - stay tuned), Computational Neuroscientist (taking online courses, dissertation in progress), and that's enough about me! Reach out and tell me about yourself🤩
*/
